import React from 'react';
import PropTypes from 'prop-types';

import styles from './Notification.module.scss';

const Type = {
    Default: '',
    Error: 'error',
    Success: 'success',
    Warning: 'warning',
    Info: 'info',
    Light: 'light'  ,
};

const Notification = ({ message, type }) => (
    <div className={ `${ styles['notification-component'] } ${ type ? styles[`notification-${ type }`] : `` }` }>
        { message }
    </div>
);

Notification.propTypes = {
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    type: PropTypes.oneOf([
        Type.Default,
        Type.Error,
        Type.Success,
        Type.Warning,
        Type.Info,
        Type.Light,
    ]),
};

export default Notification;
export { Type as NotificationType };
